module.exports = __webpack_public_path__ + "static/media/amp-guitar.3bdf0edd.svg";